module.exports = __webpack_public_path__ + "static/media/icn_play.729caa11.svg";